<template>
    <el-row>
        <el-col :span="10" class="mt-10 mb-50">
            <el-card :body-style="{minHeight:'830px'}" class="box-card">
                <!--<div slot="header">
                    <span>ALL STUDENTS</span>
                </div>-->
                <el-input
                        class="mb-10"
                        :placeholder="!teacherId  && role === 'admin' ? 'Please choose a teacher first' : searchPlaceHolder"
                        v-model="keywordsL"
                        @keyup.enter.native="handleIconClickL"
                        :disabled="!teacherId && role === 'admin' "
                >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClickL"></i>
                </el-input>
                <el-table :empty-text="(role === 'admin' &&  !tId) ? 'Please choose a teacher first' : 'No data'" :data="AllStudents" border tooltip-effect="dark" v-loading="loadingL" element-loading-text="loading..." style="width: 100%" @selection-change="AddSelection">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="Name">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.school" placement="top-start">
                                <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页符-->
                <div class="text-center mt-20 mb-50">
                    <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPageL" :page-count="totalPagesL"
                                   @current-change="pageCurrentChangeL">
                    </el-pagination>
                </div>
            </el-card>
        </el-col>
        <el-col :span="4" class="mb-50 actions" style="padding-left: 0;padding-right: 0;min-width: 85px;">
            <el-button class="ml-5 mr-5 mb-10" :disabled="this.Addlist.length === 0 || addBtnIsLoading" style="padding: 4px 17px; " @click="addRelation" type="primary" size="mini">Add<i class="el-icon-arrow-right el-icon--right pl-10"></i></el-button>
            <el-button class="pl-10 pr-10" :disabled="this.Removelist.length === 0 || removeBtnIsLoading" style="padding: 4px 17px; margin: 0 5px;" @click="removeRelation" type="primary" size="mini"><i class="el-icon-arrow-left el-icon--left pr-10"></i>Remove</el-button>
        </el-col>
        <el-col :span="10" class="mt-10 mb-50">
            <el-card :body-style="{minHeight:'830px'}">
                <!--<div slot="header">
                    <span>SELECTED STUDENTS</span>
                </div>-->
                <el-input
                        class="mb-10"
                        :placeholder="!teacherId  && role === 'admin' ? 'Please choose a teacher first' : searchPlaceHolder"
                        v-model="keywordsR"
                        @keyup.enter.native="handleIconClickR"
                        :disabled="!teacherId  && role === 'admin' "
                >
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="handleIconClickR"></i>
                </el-input>
                <el-table :empty-text="(role === 'admin' &&  !tId) ? 'Please choose a teacher first' : 'No data'" :data="MyStudents" border tooltip-effect="dark" v-loading="loadingR" element-loading-text="loading..."
                          style="width: 100%" max-height="641" @selection-change="RemoveSelection" >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column label="Name">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="dark" :content="scope.row.school" placement="top-start">
                                <span>{{scope.row.displayName + ' - ' + scope.row.givenName + '  ' +  scope.row.familyName}}</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页符-->
                <!--<div class="text-center mt-20 mb-50">
                    <el-pagination layout="prev, pager, next" :page-size="size" :current-page="currentPageR" :page-count="totalPagesR"
                                   @current-change="pageCurrentChangeR">
                    </el-pagination>
                </div>-->
            </el-card>
        </el-col>
        <el-col :span="2" class="mt-20 mb-50">

        </el-col>
    </el-row>
</template>

<script>
    import Cookies from 'js-cookie'

    export default {
        props: [
            'selecttripvalue',
            'tId'
        ],
        watch: {
            selecttripvalue() {
                this.teacherId && this.getselectlist();
            },
            tId() {
                this.teacherId && this.getselectlist();
            }
        },
        data() {
            return {
                searchPlaceHolder: 'Search anything about student',

                keywordsL: '',
                keywordsR: '',
                exceptL: true,
                exceptR: false,

                loadingL:false,
                loadingR:false,
                AllStudents: [],
                MyStudents: [],
                Addlist:[],//从左向右选中list
                Removelist:[],//从右向左选中list
                currentPageL: 1,//分页信息分左右
                currentPageR: 1,
                totalPagesL: 1,
                totalPagesR: 1,
                size: 15,
                role: '',

                // loading变量
                addBtnIsLoading: false,
                removeBtnIsLoading: false
            }
        },
        computed: {
            teacherId() {
                var cookieId = Cookies.get('teacherId');
                return this.tId || cookieId;
            }
        },
        methods: {
            //选trip搜学生
            getselectlist(){
                this.getAllStudents();
                this.getMyStudents();
            },

            //多选选中的数组
            AddSelection(val) {
                this.Addlist = val;
            },
            RemoveSelection(val) {
                this.Removelist = val;
            },

            //搜索学生信息
            handleIconClickL(){
                this.getAllStudents()
            },
            handleIconClickR(){
                this.getMyStudents()
            },

            //改变当前页函数
            pageCurrentChangeL(val){
                this.currentPageL = val;
                this.getAllStudents();
            },

            //添加relation
            addRelation(){
                const whichBtn = 'add';
                this.loadingL = true;
                this.loadingR = true;
                this.addBtnIsLoading = true;
                this.$http.post('relation',{id:this.teacherId, studentList:this.Addlist})
                    .then(res =>{
                        // 此时获取所有学生，会重新更新AllStudents
                        this.getAllStudents(whichBtn);
                        this.getMyStudents(whichBtn);
                    }).catch(error => {
                        this.$message.error(error.message),
                        this.loadingL = false;
                        this.loadingR = false;
                        this.addBtnIsLoading = false;
                    })
            },
            //移除relation
            removeRelation(){
                const whichBtn = 'remove';
                this.loadingL = true;
                this.loadingR = true;
                this.removeBtnIsLoading = true;
                this.$http.delete('relation',{data:{id:this.teacherId, studentList:this.Removelist}})
                    .then(res =>{
                        this.getAllStudents(whichBtn);
                        this.getMyStudents(whichBtn);
                    }).catch(error => {
                        this.$message.error(error.message),
                        this.loadingL = false;
                        this.loadingR = false;
                        this.removeBtnIsLoading = false;
                    })
            },

            // 根据trip过滤数组数据并返回
            filterDataByTrip(list) {
                var list = list || [];
                return list.filter(value => {
                    return value.tripId === this.selecttripvalue;
                })
            },
            // 根据关键字过滤数组数据并返回
            filterDataByKeyWords(list, keyWords) {
                var list = list || [];
                var keyWords = keyWords.toLowerCase() || '';
                return list.filter(value => {
                    let info = value.text.toLowerCase();
                    return info.indexOf(keyWords) > -1;
                })
            },

            // 根据参数控制按钮loading的初始状态
            setLoadingStartByWhichBtn(whichBtn) {
                whichBtn === 'add' ? this.addBtnIsLoading = true :
                    (whichBtn === 'remove' ? this.removeBtnIsLoading = true : '');
                this.Removelist = [];
                this.Addlist = [];
            },

            // 根据参数控制按钮loading的结束状态
            setLoadingEndByWhichBtn(whichBtn) {
                whichBtn === 'add' ? this.addBtnIsLoading = false :
                    (whichBtn === 'remove' ? this.removeBtnIsLoading = false : '');
            },

            //穿梭框-获取左边全部学生数据
            getAllStudents (whichBtn) {
                this.setLoadingStartByWhichBtn(whichBtn);
                this.loadingL = true;
                var allStudents = [];
                // 穿梭框-左-query数据
                var leftQuery = {
                    teacherId: this.teacherId,
                    size: this.size,
                    page: this.currentPageL - 1,
                    tripId: this.selecttripvalue,
                    keywords: this.keywordsL,
                    except: this.exceptL
                }
                this.$http.get('relation', {
                    params: leftQuery
                })
                .then(response => {
                    allStudents = response.list;
                    this.AllStudents = allStudents;
                    this.totalPagesL = response.totalPages;
                    this.loadingL = false;
                    this.setLoadingEndByWhichBtn(whichBtn);
                }).catch(error => {
                    this.loadingL = false;
                    this.setLoadingEndByWhichBtn(whichBtn);
                    this.$message.error(error.message);
                })
            },
            //穿梭框－获取右边已添加学生数据
            getMyStudents (whichBtn) {
                this.setLoadingStartByWhichBtn(whichBtn);
                this.loadingR = true;
                var myStudent = [];
                this.$http.get('relation/' + this.teacherId)
                    .then(response => {
                        myStudent = response;
                        if(this.selecttripvalue !== ''){
                            myStudent = this.filterDataByTrip(response);
                            if(this.keywordsR !== ''){
                                myStudent = this.filterDataByKeyWords(myStudent, this.keywordsR);
                            }
                        }else {
                            if(this.keywordsR !== ''){
                                myStudent = this.filterDataByKeyWords(myStudent, this.keywordsR);
                            }
                        }
                        this.MyStudents = myStudent;
                        // this.totalPagesR = response.totalPages;
                        this.loadingR = false;
                        this.setLoadingEndByWhichBtn(whichBtn);
                    }).catch(error => {
                        this.loadingR = false;
                        this.setLoadingEndByWhichBtn(whichBtn);
                        this.$message.error(error.message);
                        throw new Error(error);
                    })
            }

        },
        mounted() {
            this.role = Cookies.get('role');
            this.teacherId && this.getselectlist();
        }
    }
</script>

<style lang="scss" scope=""></style>


// WEBPACK FOOTER //
// TransferBox.vue?359fac7e